import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import {
  SortingState,
  SearchState,
  IntegratedFiltering,
  IntegratedSorting,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  DragDropProvider,
  Toolbar,
  SearchPanel,
} from "@devexpress/dx-react-grid-material-ui";
import MuiGrid from "@material-ui/core/Grid";
import React, { useState } from "react";

const columns = [
  { title: "Name", name: "name" },
  { title: "Email", name: "email" },
  { title: "Number of Properties", name: "numProperties" },
  { title: "Archived", name: "isArchived" },
  { title: "Actions", name: "actions" },
];

const ClientsTable = ({ data }) => {
  const classes = useStyles();
  const [columnAlignment] = useState([
    { columnName: "actions", align: "right" },
  ]);
  const [sortingStateColumnExtensions] = useState([
    { columnName: "actions", sortingEnabled: false },
  ]);

  return (
    <MuiGrid className={classes.root} container>
      <MuiGrid item xs={12}>
        <Paper>
          <Grid rows={data} columns={columns} getRowId={(row) => row.id}>
            <DragDropProvider />
            <SearchState />
            <SortingState
              defaultSorting={[{ columnName: "displayName", direction: "asc" }]}
              columnExtensions={sortingStateColumnExtensions}
            />
            <IntegratedFiltering />
            <IntegratedSorting />
            <VirtualTable
              cellComponent={(props) => <VirtualTable.Cell {...props} />}
              columnExtensions={columnAlignment}
            />
            <TableHeaderRow showSortingControls />
            <Toolbar />
            <SearchPanel />
          </Grid>
        </Paper>
      </MuiGrid>
    </MuiGrid>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 24,
    marginBottom: 24,
  },
}));

export default ClientsTable;
